export default "__VITE_ASSET__BoKQ22uv__"